import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'radio-button-component',
  styleUrl: 'radio-button-component.scss',
  shadow: true,
})
export class RadioButtonComponent {
  @Prop({ reflect: true, mutable: true }) label: string;
  @Prop({ reflect: true, mutable: true }) checked: boolean;
  @Prop({ reflect: true, mutable: true }) value: string | undefined;

  @Prop() radioButtonLabel?: string = '';
  @Prop() radioButtonPrice?: string = '';
  @Prop() radioButtonHelperText?: string = '';
  @Prop() radioButtonErrorMessage?: string = '';
  @Prop() isError: boolean = false;
  @Prop() isDisabled: boolean = false;
  @Prop() isSmallButton: boolean = false;
  @Event() valueChanged: EventEmitter<string>;

  render() {
    let descr: string;
    if (this.isError) {
      descr = this.radioButtonErrorMessage;
    } else {
      descr = this.radioButtonHelperText;
    }

    return (
      <Host>
        <div
          class={`box ${this.isSmallButton ? 'small' : ''} ${this.isDisabled ? 'disabled' : ''} ${this.isError ? 'error' : ''} ${!this.isDisabled && !this.isError ? 'default' : ''} ${this.checked ? 'checked' : ''}`}
          tabindex="0"
        >
          <div class="row">
            <label class="selector">
              <span class={`checkmark ${this.checked ? 'checked' : ''}`}></span>
            </label>
            <div class="title">{this.label}</div>
            <div class="price">{this.radioButtonPrice}</div>
          </div>
          <div class={'description'}>
            {this.isError && <span class="material-icons-outlined">error</span>}
            {descr}
          </div>
        </div>
        <div class="background"></div>
      </Host>
    );
  }
}
